import { DialogBase, DialogProps } from '../../../../components/dialogs';
import { Box, Button, Stack, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useFiles } from '../../../files';
import { useTranslation } from 'react-i18next';
import { IWantedListResponse } from '../../models';
import { FileUpload } from '../../components/FileUpload';

enum WantedListInternationalTypeEnums {
  FIFTH_SHAPE = 'fifthShape',
  SIX_SHAPE = 'sixShape',
  SEVEN_SHAPE = 'sevenShape',
  EIGHT_SHAPE = 'eightShape',
  NINTH_SHAPE = 'ninthShape',
  TEN_SHAPE = 'tenShape',
  ELEVEN_SHAPE = 'elevenShape',
  TWELVE_SHAPE = 'twelveShape',
}

interface IWantedListInternationalDialogProps extends DialogProps {
  handleValid: (values: any) => void;
  list: IWantedListResponse[];
}

export const WantedListNationalDialog: FC<IWantedListInternationalDialogProps> = ({
  handleValid,
  list,
  ...props
}) => {
  const [files, setFiles] = useState<any>({});

  const { handleInputUpload } = useFiles();
  const { t } = useTranslation();

  const handleDelete = (type: string) => {
    const shape = type.split('.')[0];
    const lang = type.split('.')[1];
    setFiles((prev: any) => ({ ...prev, [shape]: { ...prev[shape], [lang]: null } }));
  };

  const handleChangeInput = async (e: any, type: string) => {
    if (!e.target.files?.length) return;
    const shape = type.split('.')[0];
    const lang = type.split('.')[1];

    const res = await handleInputUpload(e);
    setFiles((prev: any) => ({ ...prev, [shape]: { ...prev[shape], [lang]: res } }));
  };

  useEffect(() => {
    if (list) {
      setFiles(list[0]?.files);
    }
  }, [list]);
  return (
    <DialogBase {...props} maxWidth="lg" fullWidth>
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          handleValid(files);
        }}
      >
        <Stack direction="row" gap={2}>
          <Stack gap={2} flex={1}>
            <Typography textAlign="center">Ruscha</Typography>
            {Object.values(WantedListInternationalTypeEnums).map((item) => (
              <FileUpload
                acceptedFiles=".xlsx"
                key={item}
                currentName={files?.[item]?.['ru']?.saved_name}
                handleChangeInput={(e: any) => handleChangeInput(e, `${item}.ru`)}
                handleDelete={(item) => handleDelete(`${item}.ru`)}
                item={item}
              />
            ))}
          </Stack>
          <Stack gap={2} flex={1}>
            <Typography textAlign="center">Uzbekcha</Typography>
            {Object.values(WantedListInternationalTypeEnums).map((item) => (
              <FileUpload
                acceptedFiles=".xlsx"
                key={item}
                currentName={files?.[item]?.['uz']?.saved_name}
                handleChangeInput={(e: any) => handleChangeInput(e, `${item}.uz`)}
                handleDelete={(item) => handleDelete(`${item}.uz`)}
                item={item}
              />
            ))}
          </Stack>
        </Stack>
        <Button
          sx={{ mt: 1, marginLeft: 'auto', display: 'block' }}
          variant="contained"
          type="submit"
        >
          {t('action.save')}
        </Button>
      </Box>
    </DialogBase>
  );
};
